import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import Typography from 'apollo-react/components/Typography';
import React, { useEffect, useState } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import DashboardDialog from './DashboardDialog';
import { changeDashboardEditingState } from '../../../actions/DashboardConfigActions';
import { changeLanguage } from '../../../actions/TranslationActions';
import { useTranslation } from '../../../custom-hooks/useTranslation';

const ChangeLanguageDialog = ({ open }) => {
  const [currentLanguage, setCurrentLanguage] = useState(null);
  const languages = useSelector((state) => state.translations.languages) ?? {};
  const culture = useSelector((state) => state.auth.culture || 'en-US');
  const dispatch = useDispatch();
  const translateString = useTranslation();

  useEffect(() => {
    setCurrentLanguage(culture);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => dispatch(changeDashboardEditingState('general'));

  const isCurrentLanguage = () => culture === currentLanguage;

  const dispatchChangeLanguage = () => {
    batch(() => {
      dispatch(changeLanguage(currentLanguage));
      handleClose();
    });
  };

  const handleChangeLanguage = ({ target }) => setCurrentLanguage(target.value);

  const cancelButton = {
    label: translateString('Cancel'),
    onClick: handleClose,
  };

  const acceptButton = {
    label: translateString('Change Language'),
    disabled: isCurrentLanguage(),
    onClick: () => dispatchChangeLanguage(),
  };

  const renderLanguageItems = () =>
    Object.keys(languages).map((lang, idx) => (
      <MenuItem key={idx} value={languages[lang]}>
        {lang}
      </MenuItem>
    ));

  return (
    <DashboardDialog onClose={handleClose} open={open} buttonProps={[cancelButton, acceptButton]}>
      <Typography variant="title1">{translateString('Change Language')}</Typography>
      <Select
        label={translateString('Languages')}
        value={currentLanguage}
        onChange={handleChangeLanguage}
        placeholder={`${translateString('Select language')}...`}
        fullWidth
        ui-ta="Select Language Field"
      >
        {renderLanguageItems()}
      </Select>
    </DashboardDialog>
  );
};

export default ChangeLanguageDialog;
